"use client"

import { Profile } from "@/models/profile"
import { useEditProfile } from "../hooks/useEditProfile"
import { PrimaryButton } from "@/components/Button"
import Drawer from "@/components/Drawer"
import { H1Text, Text } from "@/components/Text"
import ProfileControls from "./ProfileControls"
import EditProfileLinks from "./EditProfileLinks"
import EditDescription from "./EditDescription"
import Checkbox from "@/components/Checkbox"
import { useState } from "react"

type EditProfileProps = {
  description: string
  links: Profile["links"]
  privatePage: boolean
}

export const EditProfile = ({
  description,
  links,
  privatePage,
}: EditProfileProps) => {
  const [isPrivatePage, setIsPrivatePage] = useState(privatePage)
  const {
    newDescription,
    setNewDescription,
    linkError,
    isSaving,
    isDrawerOpen,
    setIsDrawerOpen,
    descriptionIsWithinMaxLength,
    handleSave,
  } = useEditProfile({ description, links })

  const isDisabled = isSaving || !descriptionIsWithinMaxLength

  return (
    <>
      <ProfileControls openDrawer={() => setIsDrawerOpen(true)} />

      <Drawer
        className="max-h-[45rem]"
        open={isDrawerOpen}
        close={() => setIsDrawerOpen(false)}
      >
        <div className="flex flex-col items-center justify-start w-full overflow-y-auto scrollbar-thin scrollbar-thumb-zinc-600 scrollbar-track-zinc-900">
          <div className="flex flex-col justify-center items-center">
            <H1Text>Edit Profile</H1Text>
            <Text>Edit your profile.</Text>
          </div>
          <form action={handleSave} className="w-full max-w-sm">
            <EditDescription
              descriptionIsWithinMaxLength={descriptionIsWithinMaxLength}
              description={newDescription}
              changeDescription={setNewDescription}
            />

            <EditProfileLinks links={links} linkError={linkError} />

            <Checkbox
              containerClassName="my-2"
              label="Private page"
              name="private"
              checked={isPrivatePage || false}
              onChange={() => setIsPrivatePage(!isPrivatePage)}
            />

            <PrimaryButton
              disabled={isDisabled}
              className="w-full mt-4"
              type="submit"
            >
              {isSaving ? "Saving..." : "Save"}
            </PrimaryButton>
          </form>
        </div>
      </Drawer>
    </>
  )
}
